export type ValidationLevel = 'blocker' | 'warning';

export interface ValidationItem {
  /** Stable key so React can keep rows identified across re-validation. */
  id: string;
  level: ValidationLevel;
  /** Stated as what is wrong, not as an instruction. */
  message: string;
  /** Optional one-click resolution, e.g. "Remove 3 unused placeholders". */
  fixLabel?: string;
  onFix?: () => void;
}

/** Blockers disable the state action; warnings never do. */
export const hasBlocker = (items: ValidationItem[]): boolean =>
  items.some((i) => i.level === 'blocker');
